// extracted by mini-css-extract-plugin
export default {"date":"DateMessage__date___uY879","dateContainer":"DateMessage__dateContainer___cmxNU","dateV2":"DateMessage__dateV2___QY1DK","border":"DateMessage__border___HGOfZ"};